<template>
  <v-list-item :style="(IsInactive ? 'background-color: #eeeeee !important;' : '') + (!Contact && !loading ? 'border: 1px solid red !important;' : '')"
               class="py-2">
    <v-list-item-icon class="mr-4 my-auto">
      <v-icon v-text="IsInactive ? 'mdi-account-off' : '$customer_manager'"
              :color="Contact || loading ? (IsInactive ? 'disabled' : '') : 'error' " />
    </v-list-item-icon>
    <v-list-item-content class="py-0"
                         v-if="Contact && !loading">
      <v-container class="pa-0"
                   fluid>
        <v-row no-gutters>
          <v-col>
            <v-list-item-title v-text="Contact.Name" />
          </v-col>
          <v-col>
            <v-list-item-title v-text="Contact.Email"
                               :class="Contact.EmailAllowed ? 'primary--text' : ''" />
          </v-col>
        </v-row>
        <v-row no-gutters class="mt-1">
          <v-col v-if="!hideTitle">
            <v-list-item-subtitle v-text="Contact.Title" />
          </v-col>
          <v-col v-if="!hideMobile">
            <v-list-item-title v-text="Contact.Mobile"
                               :class="Contact.SmsAllowed ? 'primary--text' : ''" />
          </v-col>
        </v-row>
      </v-container>
    </v-list-item-content>
    <v-list-item-content class="py-0"
                         v-else-if="loading">
      {{$t('servicesystem.common_objects.fallbackterms.loading')}}
    </v-list-item-content>
    <v-list-item-content class="py-0 error--text"
                         v-else>
      {{$t('servicesystem.common_objects.fallbackterms.no_customer_contact')}}
    </v-list-item-content>
    <v-list-item-action class="my-auto ml-3 d-flex flex-nowrap flex-row">
      <slot name="action-buttons" />
    </v-list-item-action>
  </v-list-item>
</template>


<script>
export default {
  name: "ContactTemplate",
  props: {
    Contact: Object,

    hideName: Boolean,
    hideTitle: Boolean,
    hideMail: Boolean,
    hideMobile: Boolean,
    loading: Boolean,
  },
  components: {},

  data: () => ({}),

  mounted() {},

  methods: {},

  computed: {
    IsInactive() {
      return this.Contact && !this.Contact.IsActive;
    },
  },

  watch: {
    Contact: function () {},
  },
};
</script>